/**
 * Formats a given timestamp into a string with the format "DD/MM/YYYY HH:MM:SS".
 *
 * @param {number} timestamp - The timestamp to format.
 * @returns {string} The formatted time string.
 */
export const formatTime = (timestamp) => {
  const date = new Date(timestamp);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};
